import httpManager from "@/app/shared/utils/httpManager";
import { TABLE_PAGE_SIZE } from "@/app/shared/utils/constants";
import {
  ReportTypes,
  PayPromiseReportTypes,
  PayPromiseReportTypesNames,
} from "@/app/reports/utils/enums";

export async function fetchList({ filters, page = 1 } = {}) {
  let query = "";
  if (filters.entity) query += `entity=${filters.entity}&`;
  query += `portfolio=${filters.portfolio}&`;
  if (filters.base) query += `base=${filters.base}&`;
  if (filters.user) query += `user=${filters.user}&`;
  query += `start_date=${filters.startDate}&`;
  query += `end_date=${filters.endDate}`;

  const pdp_type = PayPromiseReportTypesNames[PayPromiseReportTypes.List];
  const offset = (page - 1) * TABLE_PAGE_SIZE;
  const limit = TABLE_PAGE_SIZE;

  const url = `/reports/${ReportTypes.PayPromise}/?offset=${offset}&limit=${limit}&pdp_type=${pdp_type}&${query}`;

  const response = await httpManager.get(url);
  return response?.data;
}
